<template>
  <div class="mb-wrap">
    <p class="mb-intro">
      Trimite instant o notificare tuturor utilizatorilor care au aplicația deschisă
      (fără să dea refresh). Se folosește pentru anunțuri de oprire/mentenanță.
    </p>

    <div class="mb-row">
      <div class="mb-field">
        <label>Ora la care se oprește (opțional — pentru countdown)</label>
        <v-text-field v-model="oraOprire" type="time" density="compact"
          variant="outlined" hide-details style="max-width: 180px" />
      </div>
      <div class="mb-field" style="flex: 1">
        <label>Revenire estimată</label>
        <v-text-field v-model="revenire" :placeholder="'cât mai curând posibil'" density="compact"
          variant="outlined" hide-details />
      </div>
    </div>

    <div class="mb-field">
      <label>Mesaj (scrie aici textul care apare la utilizatori)</label>
      <v-textarea v-model="message" :placeholder="'ex: ' + defaultMessage" rows="3" auto-grow
        density="compact" variant="outlined" hide-details />
      <span class="mb-hint">Dacă lași gol, se trimite textul standard de mai jos (construit din ora + revenirea de mai sus).</span>
    </div>

    <label class="mb-preview-label">Așa va apărea la utilizatori:</label>
    <div class="mb-preview">
      <i class="dx-icon dx-icon-warning" />
      <span>{{ message?.trim() || defaultMessage }}</span>
    </div>

    <div class="mb-actions">
      <v-btn color="#ff2c21" :loading="sending" @click="send">
        <v-icon start>mdi-bullhorn</v-icon> Trimite notificarea
      </v-btn>
      <v-btn variant="tonal" :loading="clearing" @click="clearNotice">
        <v-icon start>mdi-bell-off</v-icon> Retrage notificarea
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import notify from "devextreme/ui/notify";
import MaintenanceService from "@/services/AUTH/MaintenanceService";

export default defineComponent({
  name: "MaintenanceBroadcast",
  data() {
    return { oraOprire: "", revenire: "", message: "", sending: false, clearing: false };
  },
  computed: {
    revenireText(): string {
      return this.revenire?.trim() || "cât mai curând posibil";
    },
    defaultMessage(): string {
      const oraPart = this.oraOprire ? ` la ora ${this.oraOprire}` : " în curând";
      return `Platforma va fi oprită${oraPart} pentru un update și revenim ${this.revenireText}. Vă rugăm să salvați ce lucrați.`;
    },
    minutesUntil(): number {
      if (!this.oraOprire) return 0;
      const [h, m] = this.oraOprire.split(":").map(Number);
      const now = new Date();
      const target = new Date(now);
      target.setHours(h, m, 0, 0);
      if (target.getTime() <= now.getTime()) target.setDate(target.getDate() + 1);
      return Math.max(1, Math.round((target.getTime() - now.getTime()) / 60000));
    },
  },
  methods: {
    async send() {
      // Compunem mereu mesajul final în frontend (WYSIWYG cu previzualizarea) și îl
      // trimitem ca atare; countdown-ul (minute) rezultă din ora aleasă.
      const finalMsg = this.message?.trim() || this.defaultMessage;
      this.sending = true;
      try {
        await MaintenanceService.broadcast(this.minutesUntil, finalMsg);
        notify("Notificarea a fost trimisă tuturor utilizatorilor.", "success", 3000);
      } catch (e: any) {
        notify(e?.response?.data?.Message || "Eroare la trimiterea notificării.", "error", 4000);
      } finally {
        this.sending = false;
      }
    },
    async clearNotice() {
      this.clearing = true;
      try {
        await MaintenanceService.clear();
        notify("Notificarea a fost retrasă.", "success", 3000);
      } catch (e: any) {
        notify(e?.response?.data?.Message || "Eroare la retragerea notificării.", "error", 4000);
      } finally {
        this.clearing = false;
      }
    },
  },
});
</script>

<style scoped>
.mb-wrap {
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.mb-intro {
  color: #64748b;
  font-size: 14px;
  margin: 0;
}
.mb-row {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
}
.mb-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.mb-field label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #94a3b8;
}
.mb-hint {
  font-size: 12px;
  color: #94a3b8;
}
.mb-preview-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #94a3b8;
  margin-bottom: -8px;
}
.mb-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 10px;
  background: repeating-linear-gradient(45deg, #ffe000, #ffe000 14px, #ffc800 14px, #ffc800 28px);
  border-bottom: 3px solid #3d2e00;
  color: #3d2e00;
  font-size: 14px;
  font-weight: 700;
}
.mb-preview .dx-icon {
  color: #3d2e00;
}
.mb-actions {
  display: flex;
  gap: 12px;
}
</style>
